import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import di from "../di/servicelocator";
import OtpPage from "../GuestUser/OtpPage";
import ErrorExclamation from "@frameworks/web/components/generic/errorExclamation";
import { loginHelp } from "../LogintextConfig";
import { loginScreenState } from "../constant";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import MainDI from "@di";
import { fetchAccountDetails } from "@frameworks/web/redux/reducers/Reports/accountDetailsThunk";
import holdingsDi from "@frameworks/web/components/Reports/HoldingReports/di/servicelocator";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
export const ClientLoginOtp = (props) => {
    const [otpButtonDisable, setOtpButtonDisable] = React.useState(false);
    const location = useLocation();
    const device = DeviceContext();
    const dispatch = useDispatch();
    const locationState = location.state;
    let navigate = useNavigate();
    const [timer, setTimer] = React.useState(true);
    const [resendOTPTimer, setResendOTPTimer] = React.useState(true);
    const [unblockState, setUnblockState] = React.useState(false);
    const { data: accountDetails, loader: accountDetailsLoader, errorData: accountDetailsError, } = useSelector((state) => state.LoginFlow.ClientLoginDataReducers);
    const { data: ClientValOTP, loader: ClientValOTPLoader, errorData: ClientValOTPError, } = useSelector((state) => state.LoginFlow.ClientValOTP);
    const submitOTP = (otp) => {
        var _a, _b;
        const payload = {
            accTyp: !!((_a = props === null || props === void 0 ? void 0 : props.otpStateObj) === null || _a === void 0 ? void 0 : _a.accType)
                ? (_b = props === null || props === void 0 ? void 0 : props.otpStateObj) === null || _b === void 0 ? void 0 : _b.accType
                : !!(props === null || props === void 0 ? void 0 : props.accType)
                    ? props === null || props === void 0 ? void 0 : props.accType
                    : locationState.accType
                        ? locationState.accType
                        : accountDetails.accountTypesArray[0],
            appData: [
                {
                    vendor: null,
                },
            ],
            userId: accountDetails.userID,
            twoFactor: String(otp),
            pwd: !!(props === null || props === void 0 ? void 0 : props.otpStateObj) && !!(props === null || props === void 0 ? void 0 : props.otpStateObj.pwd)
                ? props === null || props === void 0 ? void 0 : props.otpStateObj.pwd
                : locationState !== undefined && locationState !== null
                    ? locationState.pwd
                    : "",
        };
        di.login.getLoginData(payload);
        setTimer(false);
        if (!(device === null || device === void 0 ? void 0 : device.isDesktop)) {
            dispatch(MainDI.footer.updateShowMob_Menu(true));
            MainDI.header.RemoveHeaderData(true);
        }
    };
    useMemo(() => {
        if (unblockState) {
            setResendOTPTimer(false);
        }
    }, [unblockState, resendOTPTimer]);
    const resendOtp = () => {
        var _a, _b;
        di.login.getQuestionsData(!!(props === null || props === void 0 ? void 0 : props.otpStateObj) && !!((_a = props === null || props === void 0 ? void 0 : props.otpStateObj) === null || _a === void 0 ? void 0 : _a.resendOTPPayload)
            ? (_b = props === null || props === void 0 ? void 0 : props.otpStateObj) === null || _b === void 0 ? void 0 : _b.resendOTPPayload
            : locationState.resendOTPPayload);
        setResendOTPTimer(true);
        setTimer(true);
    };
    const getInvalidOtpSection = () => {
        if (!ClientValOTPLoader && ClientValOTPError.isOpen && otpButtonDisable) {
            switch (ClientValOTPError === null || ClientValOTPError === void 0 ? void 0 : ClientValOTPError.error.getErrCd()) {
                case "ELGN0004": {
                    if (unblockState == false) {
                        setUnblockState(true);
                    }
                    return (React.createElement(React.Fragment, null,
                        React.createElement(ErrorExclamation, { parentClass: "text-nowrap", errorMessage: loginHelp.accountBlocked, avoidBackground: true }),
                        React.createElement("div", { className: "invalidMsg DMSanM_14_500 txt_bloodRed bg_lightPinkTwo brdradius-5 mb-15" },
                            React.createElement("div", { className: "d-flex align-items-center " },
                                React.createElement("span", { className: "p-2" },
                                    "Click here to",
                                    "  ",
                                    React.createElement(EdButton, { btnTyp: "midnight-blue-underline", className: "no_bg txt-midnight-blue DMSansNormal_12_400 small-edbutton", onClick: () => {
                                            di.login.flushLoginData();
                                            di.login.flushLoginError();
                                            if (props.helpFlowPopup) {
                                                props.helpFlowPopup(loginScreenState.UNBLOCK_USER);
                                            }
                                            else {
                                                props.redirectUrl
                                                    ? navigate("/unblock-user?redirectUrl=" +
                                                        encodeURIComponent(props.redirectUrl), {
                                                        replace: true,
                                                    })
                                                    : navigate("/unblock-user");
                                            }
                                        }, value: " Unblock account", type: "button" }))))));
                }
                case "ELGN0002":
                    return (React.createElement(ErrorExclamation, { parentClass: "text-nowrap", errorMessage: loginHelp.invalidOTP, avoidBackground: true }));
                default:
                    return (React.createElement(ErrorExclamation, { errorMessage: ClientValOTPError.error.getErrMsg(), avoidBackground: true }));
            }
        }
    };
    const resetErrorState = () => {
        if (otpButtonDisable)
            setOtpButtonDisable(false);
    };
    React.useEffect(() => {
        var _a;
        if (!ClientValOTPLoader &&
            !ClientValOTPError.isOpen &&
            ClientValOTP &&
            ClientValOTP.jwtToken) {
            if (((_a = accountDetails.jwtToken) === null || _a === void 0 ? void 0 : _a.length) > 0 || !!ClientValOTP.jwtToken) {
                holdingsDi.holdingReport.getHoldingReportData();
                if (props === null || props === void 0 ? void 0 : props.skipRedirectNavigation) {
                    if (!!(props === null || props === void 0 ? void 0 : props.setAfterLogin) &&
                        typeof (props === null || props === void 0 ? void 0 : props.setAfterLogin) === "function") {
                        props === null || props === void 0 ? void 0 : props.setAfterLogin(true);
                    }
                }
                else {
                    dispatch(fetchAccountDetails());
                    if (!!props.redirectUrl) {
                        window.location.href = props.redirectUrl;
                    }
                    else {
                        navigate("/", { replace: true });
                    }
                }
            }
            else {
                if (props === null || props === void 0 ? void 0 : props.setScreenState) {
                    props === null || props === void 0 ? void 0 : props.setScreenState(loginScreenState.OTP);
                }
            }
        }
        else if (ClientValOTPError && (ClientValOTPError === null || ClientValOTPError === void 0 ? void 0 : ClientValOTPError.isOpen)) {
            setOtpButtonDisable(true);
            if (props === null || props === void 0 ? void 0 : props.setScreenState) {
                props === null || props === void 0 ? void 0 : props.setScreenState(loginScreenState.OTP);
            }
        }
    }, [ClientValOTP, ClientValOTPLoader, ClientValOTPError]);
    return (React.createElement(React.Fragment, null,
        React.createElement(OtpPage, { pageheading: "Login", customDescription: "Enter the OTP sent to registered mobile number and email ID", submit: submitOTP, btnText: "Login", showTimer: timer, setTimer: setTimer, timerValues: { min: 9, sec: 59 }, otpErrorBlocked: getInvalidOtpSection(), noTimeOutIcon: !timer || (!ClientValOTPLoader && ClientValOTPError.isOpen), 
            // otpErrorBlocked={getBlockedOtpSection()}
            // resetErrorState={() => {
            // setOtpError({
            //   errorDetails: { isOpen: false, error: null },
            //   count: 0,
            //   errCd: "",
            // });
            // }}
            errorState: (otp) => {
                if (otp.toString().length != 4)
                    return false && !ClientValOTPLoader;
                return true && !ClientValOTPLoader;
            }, resendOtp: resendOtp, resendOTPTimer: resendOTPTimer, setResendOTPTimer: setResendOTPTimer, resetErrorState: resetErrorState }),
        resendOTPTimer && (React.createElement("div", { className: "d-flex justify-content-center DMSanN_14_400 text-success pb-2" }, "OTP successfully sent."))));
};
